import { __assign, __awaiter, __generator } from "tslib";
import * as React from 'react';
import { IframeCommunicationBridge } from './Communication/iframe-communication-bridge';
import { AppHostIframe } from './Hosts/app-host-iframe';
import { useCreateAppHostSdk } from './Hosts/use-create-app-host-sdk';
import { AppInitState } from './Services/hosted-web-content-sdk.interface';
import { PermissionStatus, } from './Services/interfaces';
import { UserSettingTypes } from './Services/messages.interface';
import { overwriteFeatureFlagsState } from './Services/utils/featureFlags';
import { getMinimumAdaptiveCardSchemaVersionAsString, isHostAdaptiveCardSchemaVersionUnsupported, shouldShowHubErrorUi, } from './Services/utils/helpers';
export var MetaOsAppContainer = function (props) {
    var _a, _b, _c, _d;
    var frameContext = props.context.page.frameContext;
    var communicationBridge = (_b = (_a = props.isolationProvider) === null || _a === void 0 ? void 0 : _a.communicationBridge) !== null && _b !== void 0 ? _b : getDefaultCommunicationBridge(props.hubServices.logger);
    if (props.hostVersionsInfo &&
        props.hostVersionsInfo.adaptiveCardSchemaVersion &&
        isHostAdaptiveCardSchemaVersionUnsupported(props.hostVersionsInfo.adaptiveCardSchemaVersion)) {
        throw new Error("dialogService.cardService requires that the host specifies an adaptive card version of at least ".concat(getMinimumAdaptiveCardSchemaVersionAsString()));
    }
    if (props.hubServices.locationService || props.hubServices.barCodeService) {
        if (!props.hubServices.devicePermissionService) {
            throw new Error('devicePermissionService needs to be provided if any of following services is provided: locationService, barCodeService');
        }
    }
    // if any overriding feature flags were specified, overwrite the flag from default settings
    if (props.featureFlags) {
        overwriteFeatureFlagsState(props.featureFlags);
    }
    // TODO Bug #7306962: When logging is added, check validDomains and log any invalid domains here
    var _e = useCreateAppHostSdk(props.hostWindow, props.context, props.hubServices, props.appDefinition, communicationBridge, props.hostVersionsInfo), appHostSdk = _e.appHostSdk, appInitInfo = _e.appInitInfo;
    var theme = props.context.app.theme;
    React.useEffect(function () {
        if (theme) {
            appHostSdk.onThemeChanged && appHostSdk.onThemeChanged(theme);
            appHostSdk.onUserSettingsChanged && appHostSdk.onUserSettingsChanged(UserSettingTypes.theme, theme);
        }
    }, [theme]);
    var fileOpenPreference = props.context.app.userFileOpenPreference;
    React.useEffect(function () {
        if (fileOpenPreference) {
            appHostSdk.onUserSettingsChanged &&
                appHostSdk.onUserSettingsChanged(UserSettingTypes.fileOpenPreference, fileOpenPreference);
        }
    }, [fileOpenPreference]);
    React.useEffect(function () {
        appHostSdk.initializeAuthenticationContext(props.context);
    }, [props.context]);
    React.useEffect(function () {
        return function cleanup() {
            appHostSdk.unloadApp(props.appDefinition);
        };
    }, [props.appDefinition]);
    React.useEffect(function () {
        return function cleanup() {
            appHostSdk.unloadSDK();
        };
    }, []);
    if (shouldShowHubErrorUi(appInitInfo, props.appDefinition)) {
        return ((((_c = props.hubServices.hubUiService) === null || _c === void 0 ? void 0 : _c.getErrorUi) &&
            ((_d = props.hubServices.hubUiService) === null || _d === void 0 ? void 0 : _d.getErrorUi(appInitInfo.reason))) || React.createElement("div", null));
    }
    var isLoading = getIsLoading(props.appDefinition.showLoadingIndicator, props.hubServices, appInitInfo, appHostSdk.isCachedLaunch, appHostSdk.getCacheablePageInfo());
    var renderedHost = function () {
        var _a;
        var hostProps = __assign(__assign({}, props), { sdkHost: appHostSdk, isLoading: isLoading, frameContext: frameContext, userClickTime: (_a = props.context.app.userClickTime) !== null && _a !== void 0 ? _a : Date.now(), communicationBridge: communicationBridge, getRequiredPermissions: function () { return getRequiredPermissionsHelper(props.hubServices.devicePermissionService); } });
        if (props.isolationProvider) {
            return props.isolationProvider.renderHost(hostProps);
        }
        else {
            return React.createElement(AppHostIframe, __assign({}, hostProps));
        }
    };
    return (React.createElement(React.Fragment, null,
        isLoading && props.hubServices.hubUiService.getLoadingUi(),
        renderedHost()));
};
export var getDefaultCommunicationBridge = function (logger) { return new IframeCommunicationBridge(logger); };
/**
 * When Caching is supported, let the CacheManagementService determine the loading state
 *
 * When Caching is not supported, We honor the showLoadingIndicator flag for the apps Loading states
 */
export var getIsLoading = function (showLoadingIndicator, hubServices, appInitInfo, isCachedLaunch, pageInfo) {
    return hubServices.cacheManagementService
        ? hubServices.cacheManagementService.getIsLoading(appInitInfo, showLoadingIndicator, isCachedLaunch, pageInfo)
        : showLoadingIndicator &&
            (appInitInfo.state === AppInitState.Loading || appInitInfo.state === AppInitState.WaitingForAppLoad);
};
export var getRequiredPermissionsHelper = function (devicePermissionService) { return __awaiter(void 0, void 0, void 0, function () {
    var devicePermissionState, consentedPermissions;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!devicePermissionService) return [3 /*break*/, 2];
                return [4 /*yield*/, devicePermissionService.storageService.getPermissions()];
            case 1:
                devicePermissionState = _a.sent();
                return [3 /*break*/, 3];
            case 2:
                devicePermissionState = [];
                _a.label = 3;
            case 3:
                consentedPermissions = devicePermissionState.filter(function (permissionsState) { return permissionsState.status == PermissionStatus.Consented; });
                return [2 /*return*/, consentedPermissions];
        }
    });
}); };
//# sourceMappingURL=meta-os-app-container.js.map